const Business = () => import("@/modules/businesses/pages/Business.vue");
const Applicant = () => import("@/modules/applicants/pages/Applicant.vue");
const Summary = () => import("@/modules/applicants/pages/Summary.vue");
const DataPoints = () => import("@/modules/applicants/pages/DataPoints.vue");
const JSONPage = () => import("@/modules/applicants/pages/JSONPage.vue");

export default [
  {
    path: ":businessId",
    name: "business",
    component: Business,
    children: [
      {
        path: "owner/:applicantId",
        component: Applicant,
        props: { isOwner: true },
        children: [
          {
            path: "summary",
            name: "owner-summary",
            component: Summary,
            meta: {
              authRequired: true,
            },
          },
          {
            path: "datapoints",
            name: "owner-datapoints",
            component: DataPoints,
            meta: {
              authRequired: true,
            },
          },
          {
            path: "json",
            name: "owner-json",
            component: JSONPage,
            meta: {
              authRequired: true,
            },
          },
        ],
        meta: {
          authRequired: true,
        },
      },
    ],
    meta: {
      authRequired: true,
    },
  },
];
